import { Component, Inject } from '@angular/core';

import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { SharedModule } from '../../../_shared/shared.module';

import { Category } from '../../shared/category.model';
import { CategoryDetailComponent } from '../../category-detail/category-detail.component';

@Component({
  selector: 'app-category-modal',
  templateUrl: './category-modal.component.html',
  standalone: true,
  imports: [SharedModule, CategoryDetailComponent],
})
export class CategoryModalComponent {
  constructor(
    private ref: MatDialogRef<CategoryModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data
  ) {}

  modalTitle = this.data.title;
  category: Category = this.data.obj;
  mode = this.data.params.mode;
  defaultLanguage = this.data.params.defaultLanguage;
  additionalLanguages = this.data.params.additionalLanguages;

  // Referenced from app-category-detail
  onSavedCategory(category) {
    this.ref.close(category); // close the dialog
  }

  // Referenced from app-category-detail
  onCanceledCategory() {
    this.close();
  }

  close() {
    this.ref.close();
  }
}

// @Output() dialogSaved = new EventEmitter<any>(); // avoid closing the dialog
// this.dialogSaved.emit(category); // avoid closing the dialog
